// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"8d1063e5","92":"54484f3e","518":"9cc5c56b"}[chunkId] + ".chunk.css";
};